var suf = "bStore/";
export default {
	get(idx){
        let urls = [
            suf+'getCategories',
            suf+'getProducts',
            suf+'getInfo',
            suf+'getOrders',
            suf+'get_currency',
            suf+'getDeals',
        ]
		return urls[idx];
	},
	set(idx){
        let urls = [
            suf+'setCategory',
            suf+'setCatOrden',
            suf+'deleteCat',
            suf+'setProduct',
            suf+'setProductOrden',
            suf+'setProductGalleries',
            suf+'setGalleryOrden',
            suf+'deleteGallery',
            suf+'deleteProduct',
            suf+'setCurrency',
            suf+'setInfo',
            suf+'setOrder',
            suf+'changeStatusOrder',
            suf+'changeStatusPayOrder',
            suf+'saveDeals',
            suf+'editDealsDayContentBox',
            suf+'activeDealsDay',
            suf+'setDealsDayItems',
            suf+'delDealsDayItems',
            suf+'editDealsTitleDay'

        ]
		return urls[idx];
	},
};
